import React, {Component} from 'react';

export class Loading extends Component {
    render() {
        return (
            <div className="loading-content">
                <p className="loading-message">{this.props.message}</p>
            </div>
        )
    }
}